// extracted by mini-css-extract-plugin
export default {"root":"SelectPaymentMethod_root__HhHkw","paymentButton":"SelectPaymentMethod_paymentButton__LsYYl","icon":"SelectPaymentMethod_icon__Pm0sw"};